import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogIn, Sparkles } from "lucide-react";
import Logo from "@/components/Logo";

export default function ClientLogin() {
  const { user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user?.role === "client") navigate("/portal", { replace: true });
    if (user?.role === "team_member" || user?.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-soft px-6 py-16" data-testid="client-login-page">
      <div className="blob bg-gold w-80 h-80 -top-20 -left-20 rounded-full" />
      <div className="blob bg-teal/40 w-96 h-96 bottom-0 -right-20 rounded-full" />
      <div className="relative w-full max-w-md card p-10 text-center">
        <div className="flex justify-center mb-2">
          <Logo surface="light" to={null} testid="client-login-logo" size="h-16" />
        </div>
        <div className="eyebrow mt-2"><Sparkles className="inline w-3 h-3 mr-1 -mt-0.5" /> Client Portal</div>
        <h1 className="mt-3 text-4xl">Welcome back.</h1>
        <p className="mt-3 text-navy/65 leading-relaxed">
          Sign in to view your services, appointments, invoices, and documents — all in one place.
        </p>
        <button
          onClick={handleGoogle}
          data-testid="google-signin-button"
          className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-white border-2 border-navy/10 hover:border-navy text-navy rounded-full px-6 py-3.5 transition shadow-card hover:shadow-cardHover"
        >
          <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden>
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8a12 12 0 1 1 0-24c3 0 5.8 1.1 7.9 3l5.7-5.7C34.4 5.9 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.4 7 29.5 5 24 5 16 5 9.2 9.7 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.5l-6.5-5.5c-2 1.4-4.6 2.2-7.5 2.2-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.2 38.3 16 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2 3.7-3.7 5l6.5 5.5c-.5.5 6.9-5 6.9-14.5 0-1.2-.1-2.4-.4-3.5z"/>
          </svg>
          <span className="font-medium">Continue with Google</span>
        </button>
        <p className="mt-6 text-xs text-navy/45">
          Are you on the ConnectHer team?{" "}
          <a href="/team/login" data-testid="team-login-link" className="text-gold underline">
            Sign in here
          </a>
        </p>
      </div>
    </div>
  );
}
